import {
  TLanguage,
  languages as _languages,
  frCommonsTranslations,
  frenchProcessor,
} from '@geovelo-frontends/commons';
import i18n, { ResourceKey } from 'i18next';
import { merge } from 'lodash';
import { initReactI18next } from 'react-i18next';

import fr from '../translations/fr.json';

type TAppLanguage = 'fr';

export const languages: {
  [key in TAppLanguage]: {
    key: TLanguage;
    translation: ResourceKey;
    icon: React.JSX.Element;
    label: string;
  };
} = {
  fr: { ..._languages['fr'], key: 'fr', translation: merge(frCommonsTranslations, fr) },
};

i18n
  .use(initReactI18next)
  .use(frenchProcessor)
  .init({
    resources: languages,
    lng: 'fr',
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    postProcess: [`frenchProcessor`],
  });

export default i18n;
